
import { Suspense, lazy } from 'react';


const LoginComponent = lazy(() => import("./components/Login"));
export function Login(props) {
  return (
    <LoginComponent {...props} />
  );
}

const RegisterComponent = lazy(() => import("./components/Register"));
export function Register(props) {
  return (
    <RegisterComponent {...props} />
  );
}

const ForgotComponent = lazy(() => import("./components/Forgot"));
export function Forgot(props) {
  return (
    <ForgotComponent {...props} />
  );
}

const ResetComponent = lazy(() => import("./components/Reset"));
export function Reset(props) {
  return (
    <ResetComponent {...props} />
  );
}

const AccountLookupComponent = lazy(() => import("./components/AccountLookup"));
export function AccountLookup(props) {
  return (
    <AccountLookupComponent {...props} />
  );
}

const SSOComponent = lazy(() => import("./components/AccountLookup"));
export function SSO(props) {
  return (
    <SSOComponent {...props} />
  );
}

export const routes = [
  {
    path: "/login",
    exact: true,
    component: LoginComponent,
    name: "Login"
  },
  {
    path: "/register",
    exact: true,
    component: RegisterComponent,
    name: "Register"
  },
  {
    path: "/forgot",
    exact: true,
    component: ForgotComponent,
    name: "Forgot"
  },
  {
    path: "/AccountLookup",
    exact: true,
    component: AccountLookupComponent,
    name: "Account Lookup"
  },
  {
    path: "/SSO",
    exact: true,
    component: SSOComponent,
    name: "SSO"
  },
  {
    path: "/reset",
    exact: true,
    component: Reset,
    name: "Reset"
  }
];
